// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"3192": "91dfadc11c41","494": "4077578422d4","5320": "7f0c276968e2","6863": "454c9f289029","8357": "dd422574e14d",}[chunkId] + ".css"
}